const aaa = [
	{
		path: "huiyuanAdd",
		component: () => import("@/views/huiyuan/huiyuan/add.vue"),
		meta:{title:'会员'},
	},
	{
		path: "huiyuanEdit",
		component: () => import("@/views/huiyuan/huiyuan/edit.vue"),
		meta:{title:'会员'},
	},
	{
		path: "huiyuanSee",
		component: () => import("@/views/huiyuan/huiyuan/see.vue"),
		meta:{title:'会员',keepAlive:true},
	},
	{
		path: "huiyuanPetSee",
		component: () => import("@/views/huiyuan/huiyuan/petSee.vue"),
		meta:{title:'会员'},
	},
	{
		path: "huiyuanList",
		component: () => import("@/views/huiyuan/huiyuan/list.vue"),
		meta:{title:'会员',keepAlive:true},
	},
]
export default aaa;